import React from "react";
import Line from "../../basicComponents/Line";
import { LeftBar, RightBar } from "./styles";

export default ({ left, right, orientation }) => {
  return (
    <>
      <Line orientation={orientation}>
        <LeftBar>{left}</LeftBar>
        <RightBar>{right}</RightBar>
      </Line>
    </>
  );
};
